import { useComposedRefs } from "../utils/use-composed-refs.js";
import { useMediaAttach } from "../player/context.js";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/media/video.tsx
/**
* Renders a native `<video>` element and forwards its element ref.
*
* Inside a Player, the element is registered as the player's current media on mount and detached on unmount. It can
* also render independently when no Player context is present.
*/
const Video = forwardRef(function Video({ children, ...props }, ref) {
	const setMedia = useMediaAttach();
	const composedRef = useComposedRefs(ref, setMedia);
	return /* @__PURE__ */ jsx("video", {
		ref: composedRef,
		...props,
		children
	});
});
//#endregion
export { Video };

//# sourceMappingURL=video.js.map